import { PAGE_SIZE } from '@/constants/pageSize';
import {
  useCancelPartnershipRequest,
  useFindPartnershipRequests,
} from '@/hooks/useReceivers';
import useTableControls from '@/hooks/useTableControls';
import StyledTable from '../styled/StyledTable';
import { PARTNERSHIP_REQUEST_COLUMNS } from '@/types/receivers/PartnershipRequestColumnDef';
import Loader from '../ui/Loader';
import StyledNextPreviousButtons from '../styled/StyledNextPreviousButtons';
import { useState } from 'react';
import ModalDeletion from '../ui/ModalDeletion';
import { useToast } from '@/hooks/useToast';
import ReceiverInfoModal from './ReceiverInfoModal';
import { useTranslation } from '@/i18n';
import { useTranslatedConst } from '@/hooks/useTranslatedConst';

const PartnershipRequestsList = () => {
  const { t } = useTranslation();
  const getTranslatedConst = useTranslatedConst();
  const { page, setPage, setSorting, sortField, sorting, sortOrder } =
    useTableControls();

  const {
    data: partnershipRequestsResponse,
    isLoading,
    isSuccess,
  } = useFindPartnershipRequests({
    page,
    pageSize: PAGE_SIZE,
    sortField,
    sortOrder,
  });

  const [partnershipRequestToDeleteId, setPartnershipRequestToDeleteId] =
    useState<string | null>(null);
  const [receiverToViewId, setReceiverToViewId] = useState<string | null>(null);

  const { mutateAsync: cancelPartnershipRequest } =
    useCancelPartnershipRequest();
  const { toastAsync } = useToast();

  return isLoading ? (
    <Loader />
  ) : (
    isSuccess && (
      <div className="flex flex-col gap-6 w-full h-auto pt-4">
        <StyledTable
          columns={getTranslatedConst(PARTNERSHIP_REQUEST_COLUMNS)}
          data={partnershipRequestsResponse.requests}
          getRowId={(row) => row.id}
          sorting={sorting}
          setSorting={setSorting}
          onCancelRow={(row) => {
            setPartnershipRequestToDeleteId(row.original.id);
          }}
          onViewRow={(row) => {
            setReceiverToViewId(row.original.id);
          }}
        />
        <StyledNextPreviousButtons
          page={page}
          pageSize={PAGE_SIZE}
          setPage={setPage}
          dataLength={partnershipRequestsResponse.total}
          label="demande"
        />
        {partnershipRequestToDeleteId && (
          <ModalDeletion
            closeModal={() => setPartnershipRequestToDeleteId(null)}
            type="partnershipRequest"
            actionOnClick={async () => {
              await toastAsync(
                cancelPartnershipRequest(partnershipRequestToDeleteId),
                {
                  success: t('receivers.success.partnershipRequestCancelled'),
                },
              );
            }}
          />
        )}
        {receiverToViewId && (
          <ReceiverInfoModal
            receiverId={receiverToViewId}
            closeModal={() => setReceiverToViewId(null)}
          />
        )}
      </div>
    )
  );
};

export default PartnershipRequestsList;
